import AWS from 'aws-sdk';

const {
  REACT_APP_AWS_KEY,
  REACT_APP_AWS_SECRET,
  REACT_APP_AWS_BUCKET,
  REACT_APP_AWS_BUCKET_REGION,
} = process.env;

AWS.config.update({
  accessKeyId: REACT_APP_AWS_KEY,
  secretAccessKey: REACT_APP_AWS_SECRET,
  region: REACT_APP_AWS_BUCKET_REGION,
});

export const AWSParams = {
  Bucket: REACT_APP_AWS_BUCKET,
};

const AWSBucket = new AWS.S3({
  params: { Bucket: REACT_APP_AWS_BUCKET },
});

export default AWSBucket;
